import { DirectiveOptions } from 'vue';

export const scrollTo: DirectiveOptions = {
	update(el, { value, oldValue }) {
		if (value && value !== oldValue) {
			el.scrollIntoView({ block: 'nearest' });
		}
	},
	componentUpdated(el, { value, oldValue }) {
		if (value && value !== oldValue) {
			el.scrollIntoView({ block: 'nearest' });
		}
	},
};
